import Cookies from 'js-cookie';
import { ContactSchema } from '../../../definitions/schemas';

export interface PersistedAccessData {
  contact?: Partial<ContactSchema>;
  email?: string;
  passcode?: string;
  roomContactToken?: string;
}

export interface AccessConfirmationData {
  consent?: boolean;
  contactId?: string;
  email?: string;
  passcode?: string;
  roomContactToken?: string;
  verificationCode?: string;
}

// Keys
const ROOM_UUID_KEY = '$UUID';

// Cookie specs
const ROOM_COOKIE_EXPIRES_DAYS = 30;
const ROOM_COOKIE_KEY = `room-${ROOM_UUID_KEY}`;

// Cookie helpers
function composeCookieKey(uuid: string) {
  return ROOM_COOKIE_KEY.replace(ROOM_UUID_KEY, uuid);
}

function decodeCookieValue(
  cookieValue: string
): PersistedAccessData | undefined {
  if (cookieValue === '') return;
  return JSON.parse(atob(cookieValue));
}

function encodeCookieValue(data: PersistedAccessData): string {
  return btoa(JSON.stringify(data));
}

export default class RoomSecurity {
  public static getAccess(uuid: string): PersistedAccessData | undefined {
    const key = composeCookieKey(uuid);
    const data = Cookies.get(key);
    if (!data) return;
    try {
      return decodeCookieValue(data);
    } catch (e) {
      RoomSecurity.flushAccess(key);
    }
  }

  // We use cookies instead of localStorage to support an expiration time
  public static persistAccess(uuid: string, data: PersistedAccessData) {
    RoomSecurity.flushAccess(uuid);
    const key = composeCookieKey(uuid);
    try {
      Cookies.set(key, encodeCookieValue(data), {
        expires: ROOM_COOKIE_EXPIRES_DAYS,
      });
    } catch (e) {
      // do nothing
    }
  }

  public static flushAccess(uuid: string) {
    Cookies.remove(composeCookieKey(uuid));
  }
}
